module.exports = __webpack_public_path__ + "b6580f37dd0129a5ee13a6eb21142f31.svg";